import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { finalize } from 'rxjs/operators';

import { LoaderService } from '../services/loader.service';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderService = inject(LoaderService);

  const noLoader = ['fornecedor', 'franqueado', 'rodape'];

  const ignoreLoader = noLoader.some((url) => req.url.includes(url));

  loaderService.show(!ignoreLoader);

  const startTime = performance.now();

  return next(req).pipe(
    finalize(() => {
      const elapsedTime = performance.now() - startTime;
      const delayTime = Math.max(2500 - elapsedTime, 0);

      setTimeout(() => loaderService.hide(), delayTime);
    })
  );
};
